import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { EntityStateStore } from '@shared/store/entity-state-store';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

export interface UserGroupExtraState {
  groupToAppLinks: { [key: string]: string[] };
}

@Injectable({ providedIn: 'root' })
export class UserGroupEntityStore extends EntityStateStore<UserGroupEntity, UserGroupExtraState> {
  constructor() {
    super(() => ({ groupToAppLinks: {} }));
  }

  setAppLinksForGroup(userGroupId: string, appIds: string[]) {
    const groupToAppLinks = this.getGroupToAppLinks();
    groupToAppLinks[userGroupId] = appIds;
    this.update({
      groupToAppLinks
    });
  }

  removeAppLinkForGroup(userGroup: UserGroupEntity, app: EgiAppEntity): void {
    const groupToAppLinks = this.getGroupToAppLinks();
    const appLinksForGroup = groupToAppLinks[userGroup.id];

    const index = appLinksForGroup.findIndex(appId => appId === app.id);

    if (index > -1) {
      appLinksForGroup.splice(index, 1);
      groupToAppLinks[userGroup.id] = appLinksForGroup;
      this.update({
        groupToAppLinks
      });
    }
  }

  private getGroupToAppLinks() {
    return cloneDeep(this.getValue().groupToAppLinks);
  }
}
